module.exports = __webpack_public_path__ + "img/score.9e7379d6.webp";